import type { ReactNode } from 'react'
import { Clock, Search, Inbox, Users, AlertTriangle } from 'lucide-react'

const ICON = { clock: Clock, search: Search, inbox: Inbox, users: Users, alert: AlertTriangle }

interface Props {
  title: string
  hint?: string
  icon?: keyof typeof ICON
  action?: ReactNode
}

export function EmptyState({ title, hint, icon = 'inbox', action }: Props) {
  const Icon = ICON[icon]
  return (
    <div className="flex flex-col items-center gap-3 px-6 py-12 text-center">
      <Icon className="size-10 text-slate-300" strokeWidth={1.5} aria-hidden="true" />
      <p className="text-sm font-semibold text-slate-600">{title}</p>
      {hint && <p className="max-w-xs text-xs leading-relaxed text-slate-400">{hint}</p>}
      {action}
    </div>
  )
}
